const jiraUtils = {
  getUserConnections: (connections, user_reference_id) =>
    connections?.filter(
      conn => conn?.creator?.user_reference_id === user_reference_id
    ),
  getNonUserConnections: (connections, user_reference_id) =>
    connections?.filter(
      conn => conn?.creator?.user_reference_id !== user_reference_id
    )
};

export default jiraUtils;
